import React from "react";
import ReactDOM from "react-dom/client";
import { Log } from "oidc-client-ts";
import { RouterProvider } from "react-router-dom";
import { ConfigProvider } from "@imminently/react/context/config";
import { router } from "@/routes";

import { icons, info } from "@imminently/react/iconify/icons-json-immi";
import { addCollection } from "@iconify/react";
console.log("[icons] adding collection", info.name, icons);
addCollection(icons);

import "./index.css";
import { viteProvider } from "@/global";
import { azureProvider } from "@/AzureProvider";

if (import.meta.env.DEV) {
  Log.setLogger(console);
  Log.setLevel(Log.DEBUG);
}


const Main = () => (
  <ConfigProvider provider={azureProvider(viteProvider)}>
    <RouterProvider router={router} />
  </ConfigProvider>
);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<Main />);
